import { TriggerIcon } from '../overlay.component';

export enum Action
{
  // ImagePlaceholder
  CROP_IMAGE = 'crop_image',
  CLEAR_IMAGE = 'clear_image',
  OPEN_GALLERY = 'open_gallery',

  // TextPlaceholder
  EDIT_TEXT = 'edit_text',

  // general
  DELETE = 'delete',
}

const actionBarIcons: Array<TriggerIcon> = [];
actionBarIcons[Action.CROP_IMAGE] = {
  type: 'svg',
  value: 'crop'
};
actionBarIcons[Action.CLEAR_IMAGE] = {
  type: 'svg',
  value: 'clear'
};
actionBarIcons[Action.OPEN_GALLERY] = {
  type: 'svg',
  value: 'loop'
};
actionBarIcons[Action.DELETE] = {
  type: 'svg',
  value: 'remove'
};
actionBarIcons[Action.EDIT_TEXT] = {
  type: 'svg',
  value: 'text-editing'
};
export { actionBarIcons };



// WEBPACK FOOTER //
// ./src/app/collage-designer/stage/placeholder/overlays/action-bar/action-bar.actions.ts